import { toAbsolutePublicUrl } from "../../../services/mediaLibraryServices";

export const FALLBACK_NEWS_IMAGE = "/images/news-placeholder.jpg";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [];
}

export function stripHtml(html = "") {
  return String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", maxLength = 180) {
  const text = String(value || "").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}…`;
}

export function normalizeSearchText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function parseDate(value) {
  if (!value) return null;

  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatFullDate(value) {
  const date = parseDate(value);
  if (!date) return "";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function formatNewsDateParts(value) {
  const date = parseDate(value);

  if (!date) {
    return {
      day: "--",
      month: "---",
      year: "",
    };
  }

  return {
    day: String(date.getDate()).padStart(2, "0"),
    month: date
      .toLocaleString("fr-FR", { month: "short" })
      .replace(".", "")
      .toUpperCase(),
    year: String(date.getFullYear()),
  };
}

export function getNewsYear(value) {
  const date = parseDate(value);
  return date ? String(date.getFullYear()) : "";
}

export function isActiveNews(item) {
  return item?.is_active !== false && item?.is_active !== 0 && item?.is_active !== "0";
}

export function resolveNewsImage(item) {
  const candidate = item?.image_url || item?.photo || item?.cover_image || "";

  if (!candidate) return FALLBACK_NEWS_IMAGE;

  return toAbsolutePublicUrl(candidate) || FALLBACK_NEWS_IMAGE;
}

export function normalizeNewsItem(item) {
  const title = item?.title || "Actualité";
  const contentRaw = item?.content || "";
  const contentText = stripHtml(contentRaw);
  const createdAt = item?.created_at || item?.createdAt || "";
  const dateLabel = formatFullDate(createdAt);
  const year = getNewsYear(createdAt);

  const normalized = {
    id: item?.id,
    raw: item,

    title,
    contentRaw,
    contentText,
    excerpt: truncateText(contentText, 190),

    createdAt,
    dateLabel,
    dateParts: formatNewsDateParts(createdAt),
    year,

    image: resolveNewsImage(item),
  };

  normalized.searchIndex = normalizeSearchText(
    [normalized.title, normalized.contentText, normalized.dateLabel, normalized.year]
      .filter(Boolean)
      .join(" ")
  );

  return normalized;
}

export function sortNews(items, sort, dir) {
  const direction = dir === "ASC" ? 1 : -1;

  return [...items].sort((a, b) => {
    if (sort === "title") {
      return normalizeSearchText(a.title).localeCompare(
        normalizeSearchText(b.title),
        "fr"
      ) * direction;
    }

    const dateA = parseDate(a.createdAt)?.getTime() || 0;
    const dateB = parseDate(b.createdAt)?.getTime() || 0;

    return (dateA - dateB) * direction;
  });
}